<template>
  <v-list-group id="dropdown-radio" value="Theme">
    <template v-slot:activator="{ props }">
      <v-list-item
          prepend-icon="mdi-theme-light-dark"
          title="Theme"
          v-bind="props"/>
    </template>
    <v-radio-group v-model="darkModeConf" hide-details>
      <v-list-item @click="darkModeConf = 1">
        <template v-slot:prepend>
          <v-list-item-action>
            <v-radio :value="1"></v-radio>
          </v-list-item-action>
        </template>

        <v-list-item-title>Sombre</v-list-item-title>
      </v-list-item>
      <v-list-item @click="darkModeConf = 0">
        <template v-slot:prepend>
          <v-list-item-action>
            <v-radio :value="0"></v-radio>
          </v-list-item-action>
        </template>
        <v-list-item-title>Clair</v-list-item-title>
      </v-list-item>
      <v-list-item @click="darkModeConf = 2">
        <template v-slot:prepend>
          <v-list-item-action>
            <v-radio :value="2"></v-radio>
          </v-list-item-action>
        </template>
        <v-list-item-title>Thème de l'appareil</v-list-item-title>
      </v-list-item>
    </v-radio-group>
  </v-list-group>
</template>

<script lang="ts" setup>
const {darkModeConf} = useDarkMode()
</script>

